export default "__VITE_ASSET__B66DXLB8__"